import { createSelector } from '@ngrx/store';
import { ConfigTypes } from '../../enums/config-type.enum';
import { SnippetProfileListType } from '../../enums/profile-list-type.enum';
import * as fromApp from '../reducers/app.reducer';
import * as fromConfig from '../reducers/config.reducer';

const selectConfig = (state: fromApp.AppState) => state.config;

export const selectOrgUnitList = createSelector(selectConfig, (state: fromConfig.State) =>
    state.configs.filter((config) => config.type === ConfigTypes.OrgUnit).map((config) => config.data)
);
export const selectCountryList = createSelector(selectConfig, (state: fromConfig.State) =>
    state.configs.filter((config) => config.type === ConfigTypes.Country).map((config) => config.data)
);
export const selectCompanyList = createSelector(selectConfig, (state: fromConfig.State) =>
    state.configs.filter((config) => config.type === ConfigTypes.Company).map((config) => config.data)
);
export const allConfigs = createSelector(selectConfig, (state: fromConfig.State) => state.configs);
export const allPermissionOptions = createSelector(selectConfig, (state: fromConfig.State) => state.permissionOptions);

export const distributionProfileList = createSelector(
    selectConfig,
    (state: fromConfig.State) => state.profileLists[SnippetProfileListType.DistributionList]
);

export const fileSavedInitDataList = (docFavId: string) =>
    createSelector(selectConfig, (state: fromConfig.State) => state.savedInitData[docFavId]?.list);
export const activeInitData = (docFavId: string) =>
    createSelector(selectConfig, (state: fromConfig.State) => state.savedInitData[docFavId]?.active);
